import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Container from 'react-bootstrap/Container';

import RegistrationPage1 from '../RegistrationPage1';
import RegistrationPage2 from '../RegistrationPage2';
import RegistrationPage3 from '../RegistrationPage3';

import Labels_en from '../labels_en';
import Labels_it from '../labels_it';

class RegistrationForm extends PureComponent { 
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
    };

    if (props.lang == "it") {
      this.Labels = Labels_it;
    } else {
      this.Labels = Labels_en;
    }

  }


  
  handleSelect = (eventKey) => {
    this.state.key = eventKey;
    this.setState();
  };

  openPage2 = () => {
   
    this.setState({key: 'contacts'});
    
  }

  openPage3 = () => {
   
    this.setState({key: 'documents'});
    
  }

  componentWillMount = () => {
    console.log('RegistrationForm will mount');
  }

  componentDidMount = () => {
    console.log('RegistrationForm mounted');
  }

  componentWillReceiveProps = (nextProps) => {
    console.log('RegistrationForm will receive props', nextProps);
  }

  componentWillUpdate = (nextProps, nextState) => {
    console.log('RegistrationForm will update', nextProps, nextState);
  }

  componentDidUpdate = () => {
    console.log('RegistrationForm did update');
  }

  componentWillUnmount = () => {
    console.log('RegistrationForm will unmount');
  }

  render () {



    if (this.state.hasError) {
      return <h1>Something went wrong.</h1>;
    }
    return (
     
     <Container fluid>
       <Tabs
      id="controlled-tab-example"
      activeKey={this.state.key}
      onSelect={this.handleSelect}>

      <Tab eventKey="personal" title="Personal Info">
      <RegistrationPage1 lang={this.props.lang} onNextPage={this.openPage2} ></RegistrationPage1>
      </Tab>
      <Tab eventKey="contacts" title="Contacts">
      <RegistrationPage2 lang={this.props.lang} onNextPage={this.openPage3}></RegistrationPage2>
      </Tab>
      <Tab eventKey="documents" title="Documents">
      <RegistrationPage3 lang={this.props.lang}></RegistrationPage3>
      </Tab>
    </Tabs>
    </Container>
    );
  }
} 

RegistrationForm.propTypes = {
  // bla: PropTypes.string,
};

RegistrationForm.defaultProps = {
  // bla: 'test',
};

export default RegistrationForm;
